import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-data',
  styleUrls: [],
  template: `
    <div class="py-80 px-30 text-center bg-white">
      <picture *ngIf="showImage">
        <img
          src="../../../assets/illustrations/puzzle.svg"
          class="illustration-lg"
          alt=""
        />
      </picture>
      <p class="text-sm text-dark">{{ message }}</p>
    </div>
  `,
})
export class EmptyDataComponent implements OnInit {
  @Input() message: string;
  @Input() showImage: boolean | undefined = true;
  constructor() {}

  ngOnInit(): void {}
}
